export default "__VITE_PUBLIC_ASSET__f32a1e83__"